import { gql } from '@edreamsodigeo/frontend-api-client';

const GET_TRIP_QUERY = gql`
  query getTrip($email: String!, $bookingId: Long!) {
    getTrip(email: $email, bookingId: $bookingId) {
      trip {
        id
        bookingStatus
        accommodationBooking {
          id
        }
        itinerary {
          legs {
            duration
            sections {
              flightStatus
              departure {
                cityIata
                cityName
                countryCode
                countryName
                iata
                id
                name
              }
              pnr
              arrivalDate
              departureDate
              flightCode
              transportType
            }
          }
          origin {
            iata
            name
            countryName
            id
            countryCode
            cityName
            cityIata
          }
          destination {
            iata
            name
            countryName
            id
            countryCode
            cityName
            cityIata
          }
          arrivalDate
          departureDate
          tripType
          itineraryType
        }
        travellers {
          travellerType
        }
        buyer {
          country
          zipCode
          cpf
          address
          stateName
          dateOfBirth
          name
          mail
        }
        prime
        tdToken
      }
    }
  }
`;

export const GET_TRIP_BY_TOKEN_QUERY = gql`
  query AdditionalProducts_getTripByToken($token: String!) {
    getTripByToken(token: $token) {
      trip {
        id
        bookingStatus
        accommodationBooking {
          id
        }
        itinerary {
          legs {
            duration
            sections {
              flightStatus
              departure {
                cityIata
                cityName
                countryCode
                countryName
                iata
                id
                name
              }
              pnr
              arrivalDate
              departureDate
              flightCode
              transportType
            }
          }
          origin {
            iata
            name
            countryName
            id
            countryCode
            cityName
            cityIata
          }
          destination {
            iata
            name
            countryName
            id
            countryCode
            cityName
            cityIata
          }
          arrivalDate
          departureDate
          tripType
          itineraryType
        }
        travellers {
          travellerType
        }
        buyer {
          country
          zipCode
          cpf
          address
          stateName
          dateOfBirth
          name
          mail
        }
        prime
        tdToken
      }
    }
  }
`;

export default GET_TRIP_QUERY;
